import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "../facebook/Facebook.module.scss";
import { Link } from "react-router-dom";

export class Facebook extends Component {
  static propTypes = {};

  render() {
    const websiteInfo = [
      {
        url: "https://www.cyberhelpindia.com/chi-admin/products/15372942263880141.png",
        name: "Facebook Reach Basic",
        pra: "NO. OF REACH 400000 - 500000 PEOPLE",
        infoList: [
          {
            list: " Facebook Page Optimization",
          },
          {
            list: " Reach Maximum People ( 400000 - 500000 REACH )",
          },
          {
            list: " Alternative Day Facebook Posts ( 4 Nos. )",
          },
          {
            list: " 3 Target Locations.",
          },
          {
            list: " Facebook Group Creation",
          },
          {
            list: " Facebook Cover Design",
          },
          {
            list: " Facebook DP Design",
          },
          {
            list: " Facebook Goal Ad Setup",
          },
          {
            list: " Facebook Ads Manager Setup",
          },
        ],
        del: "Delivery in :",
        day: "30 day",
        butonOne: "get Quote",
        buttonTwo: "details",
      },
      {
        url: "https://www.cyberhelpindia.com/chi-admin/products/6939face.png",
        name: "Facebook Reach Starter",
        pra: "NO. OF REACH 900000 - 1000000 PEOPLE",
        infoList: [
          {
            list: " Facebook Page Optimization",
          },
          {
            list: " Reach Maximum People ( 900000 - 1000000 Reach )",
          },
          {
            list: " Additional Like 100 Nos",
          },
          {
            list: " Alternative Day Facebook Posts ( 8 Nos. )",
          },
          {
            list: " 5 Target Locations",
          },
          {
            list: " Facebook Group Creation",
          },
          {
            list: " Facebook Cover Design",
          },
          {
            list: " Facebook Goal Ad Setup",
          },
          {
            list: " Facebook Ads Manager Setup",
          },
        ],
        del: "Delivery in :",
        day: "30 day",
        butonOne: "get Quote",
        buttonTwo: "details",
      },
      {
        url: "https://www.cyberhelpindia.com/chi-admin/products/15834328101825324.jpg",
        name: "Facebook Reach Advance",
        pra: "NO. OF REACH 1800000 - 2000000 PEOPLE",
        infoList: [
          {
            list: " Facebook Page Optimization",
          },
          {
            list: " Reach Maximum People ( 1800000 - 2000000 Reach )",
          },
          {
            list: " Additional Like 5000 Nos.",
          },
          {
            list: "Alternative Day Facebook Posts ( 13 Nos. )",
          },
          {
            list: " 25 Target Locations",
          },
          {
            list: " Facebook Group Creation",
          },
          {
            list: " Facebook Cover Design",
          },
          {
            list: " Facebook DP Design",
          },
          {
            list: "Facebook Ads Manager Setup",
          },
        ],
        del: "Delivery in :",
        day: "30 day",
        butonOne: "get Quote",
        buttonTwo: "details",
      },
    ];

    return (
      <div>
        <section className={styles.website}>
          {websiteInfo.map((web) => {
            return (
              <div>
                <div className={styles.wrap}>
                  <div className={styles.imgs}>
                    <img src={web.url} alt="" />
                  </div>
                  <div className={styles.info}>
                    <h2>
                      <Link
                        href="online-product/nano-website-design"
                        class="th-color"
                      >
                        {web.name}
                      </Link>
                    </h2>
                    <p>{web.pra}</p>
                    <ul>
                      {web.infoList.map((weblist) => {
                        return <li>{weblist.list}</li>;
                      })}
                    </ul>
                  </div>
                  <div className={styles.btn_grp}>
                    <h3>
                      {web.del} <span>{web.day}</span>{" "}
                    </h3>
                    <button>{web.butonOne}</button>
                    <button>{web.buttonTwo}</button>
                  </div>
                </div>
              </div>
            );
          })}
        </section>
        <section className={styles.website_mobile}>
          <div className="container">
            <div className={styles.back_button}>
              <Link to="/service">
                <i class="fa fa-arrow-left" aria-hidden="true"></i> Back
              </Link>
            </div>
            {websiteInfo.map((web) => {
              return (
                <div>
                  <div className={styles.wrap}>
                    <div className={styles.imgs}>
                      <img src={web.url} alt="" />
                    </div>
                    <div className={styles.info}>
                      <h2>
                        <Link
                          href="online-product/nano-website-design"
                          class="th-color"
                        >
                          {web.name}
                        </Link>
                      </h2>
                      <p>{web.pra}</p>
                      <div className={styles.btn_grp}>
                        <h3>
                          {web.del} <span>{web.day}</span>{" "}
                        </h3>
                        <button>{web.butonOne}</button>
                        <button>{web.buttonTwo}</button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </div>
    );
  }
}

export default Facebook;
